export default __webpack_public_path__ + "static/media/logo-example-03.f022fe51.jpg";